import {FC, useState, useEffect, Fragment} from 'react'

import {Col, Form, Modal, Row} from 'react-bootstrap'
import AddPersonModal from './AddPersonModal'
import Api from '../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import ConfirmDeleteModal from './ConfirmDeleteModal'

const api = new Api()

type Props = {
  listOnly: boolean
  lists: any
  refreshTeams: any
  asTeam: any
}

const TeamListContent: FC<Props> = ({listOnly, lists, refreshTeams, asTeam}) => {
  const [showModalAddPerson, setShowModalAddPerson] = useState(false)
  const [showModalConfirmDelete, setShowModalConfirmDelete] = useState(false)
  const [selectedEmployee, setSelectedEmployee] = useState({})
  const [loading, setLoading] = useState(false)

  const handleShowModalAddPerson = (action: boolean) => {
    setShowModalAddPerson(action)
  }

  const handleShowModalConfirm = (action: boolean) => {
    setShowModalConfirmDelete(action)
    setSelectedEmployee({})
  }

  const handleRefreshTeams = (isRefresh: boolean) => {
    refreshTeams(isRefresh)
  }

  const status = (status: string) => {
    if (status === 'belum lengkap') {
      return <span className='badge badge-light-danger'>Belum Lengkap</span>
    }
    return <span className='badge badge-light-success'>Lengkap</span>
  }

  const handleDelete = (data: object) => {
    setShowModalConfirmDelete(true)
    setSelectedEmployee(data)
  }

  return (
    <>
      <AddPersonModal
        showModalAddPerson={showModalAddPerson}
        handleShowModalAddPerson={handleShowModalAddPerson}
        handleRefreshTeams={handleRefreshTeams}
      />

      <ConfirmDeleteModal
        showModalConfirmDelete={showModalConfirmDelete}
        handleShowModalConfirm={handleShowModalConfirm}
        data={selectedEmployee}
        handleRefreshTeams={handleRefreshTeams}
      />

      <div className='col-md-12 mt-15'>
        <p className='h6 mb-3'>
          Nama Anggota<i className='text- text-primary'>*</i>
        </p>

        <div style={{backgroundColor: '#F4F7FE'}} className='border rounded p-4 mt-4'>
          <div
            className='d-flex justify-content-between'
            style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
          >
            <p className='fw-bold'>
              <i className='bi bi-person-circle text-black' /> {lists?.users?.fullname}
              <span className='badge badge-light-danger text-primary'>Ketua Kelompok</span>
            </p>
          </div>

          <a
            target='_blank'
            href={lists?.users?.fileKesehatan?.file}
            style={{color: '#575757'}}
            className='mt-3 d-flex justify-content-between'
          >
            <p className='fw-bold'>Surat Keterangan Kesehatan</p>
            {status(lists?.users?.fileKesehatan?.status)}
          </a>

          {lists?.users?.detail?.is_kerja == 1 ? (
            <a
              target='_blank'
              href={lists?.users?.fileKerja?.file}
              style={{color: '#575757'}}
              className='mt-3 d-flex justify-content-between'
            >
              <p className='fw-bold'>Surat Keterangan Izin dari Tempat Kerja</p>
              {status(lists?.users?.fileKerja?.status)}
            </a>
          ) : null}

          <a
            target='_blank'
            href={lists?.users?.fileKomitmen?.file}
            style={{color: '#575757'}}
            className='mt-3 d-flex justify-content-between'
          >
            <p className='fw-bold'>Surat Pernyataan</p>
            {status(lists?.users?.fileKomitmen?.status)}
          </a>
        </div>

        {lists?.anggota?.map((item: any, key: number) => {
          return (
            <div key={key} style={{backgroundColor: '#F4F7FE'}} className='border rounded p-4 mt-4'>
              <div
                className='d-flex justify-content-between'
                style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
              >
                <p className='fw-bold'>
                  <i className='bi bi-person-circle text-black' /> {item?.nama_anggota}
                </p>

                {!asTeam ? (
                  listOnly ? null : (
                    <button onClick={() => handleDelete(item)}>
                      <i className='fa fa-trash' />
                    </button>
                  )
                ) : null}
              </div>

              <a
                target='_blank'
                style={{color: '#575757'}}
                href={item?.fileKesehatan?.file}
                className='mt-3 d-flex justify-content-between'
              >
                <p className='fw-bold'>Surat Keterangan Kesehatan</p>
                {status(item?.fileKesehatan?.status)}
              </a>

              {item?.is_kerja == 1 ? (
                <a
                  target='_blank'
                  href={item?.fileKerja?.file}
                  style={{color: '#575757'}}
                  className='mt-3 d-flex justify-content-between'
                >
                  <p className='fw-bold'>Surat Keterangan Izin dari Tempat Kerja</p>
                  {status(item?.fileKerja?.status)}
                </a>
              ) : null}

              <a
                target='_blank'
                style={{color: '#575757'}}
                href={item?.fileKomitmen?.file}
                className='mt-3 d-flex justify-content-between'
              >
                <p className='fw-bold'>Surat Pernyataan</p>
                {status(item?.fileKomitmen?.status)}
              </a>
            </div>
          )
        })}

        {!asTeam ? (
          listOnly ? null : (
            <>
              <div
                onClick={() => handleShowModalAddPerson(true)}
                className='d-flex justify-content-between border rounded p-4 mt-4'
                style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
              >
                <p className='fw-bold'>
                  <i className='bi bi-person-plus-fill text-black' /> Tambahkan Anggota
                </p>
              </div>

              <p style={{color: '#667085', fontSize: '10px'}} className='mt-2'>
                Setiap kelompok terdiri dari minimal 4 dan maksimal 7 orang.
              </p>
            </>
          )
        ) : null}
      </div>
    </>
  )
}

const TeamList: FC<Props> = ({listOnly, lists, refreshTeams, asTeam}) => {
  return (
    <TeamListContent
      listOnly={listOnly}
      lists={lists}
      refreshTeams={refreshTeams}
      asTeam={asTeam}
    />
  )
}

export default TeamList
